module.exports = __webpack_public_path__ + "img/Cookie_1_resize_40.81ea469b.png";